import i18n from '@sola/locales/index.js';
import { UserError } from '@sola/shared-utils/errors-user.js';
import { isUserError } from '@sola/shared-utils/httpClient.js';

const getErrorTranslationKey = (
  error: UserError | unknown,
  defaultTranslationKey: string,
): string => {
  if (isUserError(error) && error.type) {
    const translationKey = `errors.${error.type}`;
    if (i18n.exists(`my:${translationKey}`)) {
      return translationKey;
    }
  }

  return `errors.${defaultTranslationKey}`;
};

export const getErrorTranslationKeys = (
  fallbackTranslationKey: string,
  errors?: UserError | UserError[] | unknown,
): string[] => {
  if (Array.isArray(errors)) {
    return errors.map((err) =>
      getErrorTranslationKey(err, fallbackTranslationKey),
    );
  }

  return [getErrorTranslationKey(errors, fallbackTranslationKey)];
};
